export const AD = {};

AD.copy = {
    lt: {
        skip: "Praleisti",
        "nav.os": "OS",
        "nav.folder": "Open Folder",
        "nav.plant": "Plant Plan",
        "nav.skills": "Paslaugos",
        "nav.contact": "Kontaktai",
        "icon.me": "Antanas",
        "icon.skills": "Paslaugos",
        "icon.net": "Produktai",
        "win.skills": "Paslaugos",
        "win.net": "Produktai",
        "win.os": "OS · darbo stalas",
        "app.tasks": "Užduotys",
        "app.stock": "Sandėlis",
        "app.mail": "Paštas",
        "app.chat": "Chat",
        "pane.today": "Šiandien · 3 atviros",
        "pane.stock": "Katalogas · gyvas",
        "pane.mail": "Paštas · 2 nauji",
        "pane.chat": "Gamyba",
        t1: "Patvirtinti priėmimą",
        t2: "Brėžinio korekcija",
        t3: "Laiškas tiekėjui",
        d1: "sandėlis",
        d2: "cechas",
        d3: "paštas",
        sand: "Smėlis 0/2",
        gravel: "Skalda 8/16",
        m1: "M-214 patvirtinta",
        m2from: "Tiekimas",
        m2: "Pristatymas rytoj",
        c1: "Ar M-214 jau patvirtinta?",
        c2: "Taip — checklist’e.",
        c3: "Krauname rytą.",
        "os.go": "Atidaryti OS →",
        "sk.web": "Web",
        "sk.sys": "Sistemos",
        "sk.home": "Namai",
        "sk.d3": "3D / braižyba",
        "sk.netw": "Tinklai",
        "sk.auto": "Automatizavimas",
        "sk.design": "Dizainas",
        "sk.model": "Modelis",
        "sk.web.k": "Svetainės ir web sistemos",
        "sk.web.p": "Svetainė su paskyra, administravimu ir duomenimis. Veikia ir plečiama.",
        "sk.sys.k": "Verslo sistemos",
        "sk.sys.p": "Darbastalio programa, portalas ir licencijos — viena sistema. Darbas kompiuteryje, valdymas naršyklėje.",
        "sk.sys.and": "ir",
        "sk.sys.lic": "Licencijos",
        "sk.home.k": "Išmanieji namai",
        "sk.home.p": "Šviesa, šildymas, elektra ir prieiga — viena namų sistema. Valdymas iš vieno ekrano visam namui, automatikos veikia pačios. Paliekama veikti ir plėsti.",
        "sk.d3.k": "3D modeliavimas ir braižyba",
        "sk.d3.p": "Brėžinys, kurį galima gaminti — ne tik peržiūrėti. 2D ir 3D, korekcijos ir perbraižymas. Objekto skenavimas ir dervos spauda smulkioms detalėms, iki 14,5 × 14,5 × 18,5 cm.",
        "sk.d3.scan": "Skenavimas",
        "sk.d3.print": "Dervos spauda",
        "sk.netw.k": "Tinklai ir saugykla",
        "sk.netw.p": "Tinklas, saugykla ir stebėjimas — viena infrastruktūra objektui. Failai su teisėmis ir atsarginėmis kopijomis, nuotolinė prieiga, kameros visoje teritorijoje.",
        "sk.auto.k": "Procesų automatizavimas",
        "sk.auto.p": "Pasikartojantys darbai paliekami sistemai: ataskaitos, duomenų perkėlimas, programų sujungimas. Tas pats nebekartojamas ranka kiekvieną dieną.",
        "sk.auto.int": "Integracija",
        "sk.design.k": "Vizualinis identitetas",
        "sk.design.p": "Prekės ženklas sudedamas į vieną sistemą: logotipas, spalvos, šriftas. Tas pats identitetas svetainėje, blankuose ir reklamoje.",
        "sk.design.logo": "Logotipas",
        "sk.design.id": "Identitetas",
        "sk.design.ads": "Reklama",
        "sk.model.k": "Modelis reklamai ir filmui",
        "sk.model.p": "Veidas kadre: reklama, komercinė fotografija, vaizdo klipai ir vaidmuo. Nuotrauka ar filmas — tas pats žmogus prieš kamerą.",
        "sk.model.go": "Profilis →",
        "me.role": "Sistemos ir produktai · Vievis",
        "me.text": "Nuo idėjos iki veikiančio projekto: OS, svetainės, Windows programos.",
        "me.hire": "Susisiekti",
        "net.os": "Įmonės sistema: užduotys, sandėlis, paštas, pokalbiai.",
        "net.of": "Windows programa ir licencijų portalas. Failai atsidaro iš nuorodos.",
        "net.pp": "Kraštovaizdžio planavimas.",
        live: "Veikia",
        soon: "Netrukus",
        "task.1": "Patvirtinti priėmimą · sandėlis",
        "task.2": "Brėžinio korekcija · cechas",
        "task.3": "Laiškas tiekėjui · paštas",
        "folder.path": "Kelias",
        "folder.go": "Sukurti nuorodą",
        "folder.copy": "Kopijuoti",
        "page.os.p": "Užduotys, sandėlis, paštas, pokalbiai — vienas stalas.",
        "page.of.p": "Įklijuok Windows kelią. Gausi nuorodą, kurią atidaro programa.",
        "page.pp.p": "Sklypas, augalai, užsakymas. Netrukus — ir įrašas OS.",
        "cta.k": "Kontaktai",
        "cta.t": "Antanas Urbanavičius",
        "cta.p": "Sistema, svetainė ar kadras reklamai — parašykite, aptarsime.",
        "cta.mail": "El. paštas",
        "cta.phone": "Telefonas",
    },
    en: {
        skip: "Skip",
        "nav.os": "OS",
        "nav.folder": "Open Folder",
        "nav.plant": "Plant Plan",
        "nav.skills": "Services",
        "nav.contact": "Contact",
        "icon.me": "Antanas",
        "icon.skills": "Services",
        "icon.net": "Products",
        "win.skills": "Services",
        "win.net": "Products",
        "win.os": "OS · desk",
        "app.tasks": "Tasks",
        "app.stock": "Warehouse",
        "app.mail": "Mail",
        "app.chat": "Chat",
        "pane.today": "Today · 3 open",
        "pane.stock": "Catalog · live",
        "pane.mail": "Mail · 2 new",
        "pane.chat": "Production",
        t1: "Confirm intake",
        t2: "Drawing edit",
        t3: "Mail to supplier",
        d1: "warehouse",
        d2: "shop floor",
        d3: "inbox",
        sand: "Sand 0/2",
        gravel: "Gravel 8/16",
        m1: "M-214 approved",
        m2from: "Supply",
        m2: "Delivery tomorrow",
        c1: "Is M-214 approved yet?",
        c2: "Yes — on the checklist.",
        c3: "We load in the morning.",
        "os.go": "Open OS →",
        "sk.web": "Web",
        "sk.sys": "Systems",
        "sk.home": "Home",
        "sk.d3": "3D / drafting",
        "sk.netw": "Networks",
        "sk.auto": "Automation",
        "sk.design": "Design",
        "sk.model": "Model",
        "sk.web.k": "Sites and web systems",
        "sk.web.p": "A site with accounts, admin and data. It runs, and it can grow.",
        "sk.sys.k": "Business systems",
        "sk.sys.p": "A desktop app, a portal and licensing — one system. Work on the computer, management in the browser.",
        "sk.sys.and": "and",
        "sk.sys.lic": "Licensing",
        "sk.home.k": "Smart home",
        "sk.home.p": "Lights, heating, power and access — one home system. One screen for the whole house, automations that run themselves. Left running, and ready to grow.",
        "sk.d3.k": "3D modeling and drafting",
        "sk.d3.p": "A drawing that can be manufactured, not just viewed. 2D and 3D, edits and redraws. Object scanning and resin prints for small parts, up to 14.5 × 14.5 × 18.5 cm.",
        "sk.d3.scan": "Scanning",
        "sk.d3.print": "Resin print",
        "sk.netw.k": "Networks and storage",
        "sk.netw.p": "Network, storage and surveillance — one infrastructure for the site. Files with access rights and backups, remote access, cameras across the premises.",
        "sk.auto.k": "Process automation",
        "sk.auto.p": "Repeating work is left to the system: reports, moving data, connecting programs. The same task is no longer done by hand every day.",
        "sk.auto.int": "Integration",
        "sk.design.k": "Visual identity",
        "sk.design.p": "A brand built as one system: mark, colour, type. The same identity on the site, stationery and ads.",
        "sk.design.logo": "Logo",
        "sk.design.id": "Identity",
        "sk.design.ads": "Ads",
        "sk.model.k": "Model and on-camera talent",
        "sk.model.p": "A face for ads, commercial photography, video and film. Stills or a role — the same person in front of the camera.",
        "sk.model.go": "Profile →",
        "me.role": "Systems and products · Vievis",
        "me.text": "From idea to a working project: OS, sites, Windows apps.",
        "me.hire": "Contact",
        "net.os": "Company system: tasks, warehouse, mail, messaging.",
        "net.of": "Windows app and license portal. Files open from a link.",
        "net.pp": "Landscape planning.",
        live: "Live",
        soon: "Soon",
        "task.1": "Confirm intake · warehouse",
        "task.2": "Drawing edit · shop floor",
        "task.3": "Mail to supplier · inbox",
        "folder.path": "Path",
        "folder.go": "Make link",
        "folder.copy": "Copy",
        "page.os.p": "Tasks, warehouse, mail, chat — one desk.",
        "page.of.p": "Paste a Windows path. You get a link the app opens.",
        "page.pp.p": "Plot, plants, order. Soon it will also land in OS.",
        "cta.k": "Contact",
        "cta.t": "Antanas Urbanavičius",
        "cta.p": "A system, a site, or a face for the campaign — write, we’ll talk.",
        "cta.mail": "Email",
        "cta.phone": "Phone",
    },
};

AD.bootLines = {
    lt: [
        ["antiusdragon", "ok"],
        ["paslaugos", "ready"],
        ["ui", "loaded"],
    ],
    en: [
        ["antiusdragon", "ok"],
        ["services", "ready"],
        ["ui", "loaded"],
    ],
};
